import { P2TextDescription } from 'react-bootstrap-common-script';
import { TextNumbering } from '../../text/text-numbering';
import { APPLICANT_CONVEYANCING_CONSENT } from '../../../config/tnc/applicant_conveyancing_consent';
import { TncDocumentTemplate, TncItem } from '../../../models/interfaces/terms-and-conditions.interface';

function renderItems(items: TncItem[], level = 0): React.ReactNode {
  return items.map((item) => (
    <div key={`${level}-${item.id}`} className={level > 0 ? 'ml-4 mt-3' : 'mt-3'}>
      <TextNumbering number={item.id} description={item.text} />

      {item.note?.text && (
        <p className='mt-2 mb-0' style={{ color: '#323232' }}>
          {item.note.text}
        </p>
      )}

      {item.children && item.children.length > 0 && <div className='mt-2'>{renderItems(item.children, level + 1)}</div>}
    </div>
  ));
}

function HdbSolicitorTNC() {
  const currentTnc: TncDocumentTemplate = APPLICANT_CONVEYANCING_CONSENT;

  return (
    <div className='polymer-hdb-solicitor-form-tnc'>
      <P2TextDescription size='1.125rem' color='#000' title='Terms and Conditions' />

      <p className='mt-3' style={{ color: '#323232' }}>
        {currentTnc.content.intro}
      </p>

      <div className='polymer-hdb-solicitor-form-tnc-numbering'>{renderItems(currentTnc.content.items)}</div>

      {currentTnc.content.note?.text && (
        <p className='mt-4' style={{ color: '#323232' }}>
          {currentTnc.content.note.text}
        </p>
      )}
    </div>
  );
}

export default HdbSolicitorTNC;
